import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'flatpickr/dist/themes/material_blue.css'; // or your theme
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { useNavigate, useParams } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'




const GuestIntakeFormMoveIn = () => {

  const navigate = useNavigate();
  const { id } = useParams();

  const [beds, setBeds] = useState([]);
    const [availableBeds, setAvailableBeds] = useState([]);

  const [properties, setProperties] = useState([]);
  const [floors, setFloors] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [bedTypes, setBedTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isUnitSelected, setIsUnitSelected] = useState(false);
  const [isPaid, setIsPaid] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
  

  const [filter, setFilter] = useState({
    id: "",
    floor_id: "",
    room_id: "",
    bedtype: "",

  });

  const [moveIn, setMoveIn] = useState({
    id: id,
    bed_id: "",
    desired_move_in_date: "",
    monthly_rate: "",
  });

  // Load data on mount
  useEffect(() => {
    getFloors();
    getRooms();
    getBedTypes();
    getBeds();
        getAvailableBeds();

    getGuest();
  }, []);



  const getGuest = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-guest/${id}`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      setMoveIn(response.data?.guest);
      const guest = response.data?.guest;
      setIsPaid(( guest?.stripe_subscription_id || guest.stripe_payment_method_id ));

      setIsUnitSelected(response.data?.guest?.bed_id > 0);

    } catch (error) {
      globalErrorHandler(error, navigate);
    } finally {
      setLoading(false);
    }
  };


  const getFloors = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-floors`, { withCredentials: true });
      if (res.data.status) {
        setFloors(res.data.floors || []);
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    }
  };


  const getRooms = async (floorId) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-rooms?floor_id=${floorId}`, { withCredentials: true });
      if (res.data.status) {
        setRooms(res.data.rooms || []);
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    }
  };

  const getBeds = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-beds`, { withCredentials: true });
      if (res.data.status) {
        setBeds(res.data.beds || []);
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    }
  };



  const getAvailableBeds = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-available-beds`, { withCredentials: true });
      if (res.data.status) {
        setAvailableBeds(res.data.beds || []);
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    }
  };


  const getBedTypes = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-bedtypes`, { withCredentials: true });
      if (res.data.status) {
        setBedTypes(res.data.bedtypes || []);
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    }
  };


  const formatDate = (date) => {
    if (!date) return "";


     const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;

//    return date.toISOString().split("T")[0];
  };


  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter(prev => ({ ...prev, [name]: value }));

  if (name === "floor_id") {
      setFilter(prev => ({ ...prev, room_id: "" }));
      setRooms([]);
      getRooms(value);
    }
  };

  const handleApplyFilters = async () => {
    try {
      const {  floor_id, room_id, bedtype } = filter;

      const queryParams = new URLSearchParams();

      if (floor_id) queryParams.append("floor_id", floor_id);
      if (room_id) queryParams.append("room_id", room_id);
      if (bedtype) queryParams.append("bedtype", bedtype);

      const response = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-available-beds?${queryParams.toString()}`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.data?.status) {
        setAvailableBeds(response.data.beds); // adjust if response is wrapped
      } else {
        Swal.fire("Error", "Failed to apply filters", "error");
      }
    } catch (error) {
      globalErrorHandler(error, navigate);

    }
  };


  const handleSaveAndSelectUnit = async () => {
    if (!moveIn.bed_id) {
      Swal.fire("Please select a bed.", "", "warning");
      return;
    }

    try {
            setIsDisabled(true);

      const response = await axios.put(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/update-guest-bed`,
        { id: moveIn.id, bed_id: moveIn.bed_id, monthly_rate: moveIn.monthly_rate },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.data.status) {
        //Swal.fire("Saved", "Bed selection saved successfully.", "success");
        setIsUnitSelected(true);
      } else {
        Swal.fire("Error", response.data.message || "Save failed.", "error");
      }
            setIsDisabled(false);

    } catch (error) {
            setIsDisabled(false);

      globalErrorHandler(error, navigate);

    }
  };

  const handleSaveAndNext = async () => {
    const { desired_move_in_date } = moveIn;

    if (!desired_move_in_date) {
      Swal.fire("Missing Fields", "Please enter desired move-in date and rate.", "warning");
      return;
    }

    try {
            setIsDisabled(true);

      const response = await axios.put(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/update-guest-desired-move-in-date`,
        {
          id: moveIn.id,
          desired_move_in_date: desired_move_in_date,

        },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.data.status) {
        //  Swal.fire("Saved", "Move-in details saved.", "success");
        navigate(`/overseer/guest-management/guest-intake-form-move-in-door/${id}`);




      } else {
        Swal.fire("Error", response.data.message || "Save failed.", "error");
      }
                  setIsDisabled(false);

    } catch (error) {
                  setIsDisabled(false);

      globalErrorHandler(error, navigate);

    }
  };

  const handleCancelAndDiscard = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will remove the selected bed and reset the form.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, discard",
    });

    if (!confirm.isConfirmed) return;

    try {
                        setIsDisabled(true);

      const response = await axios.put(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/update-guest-bed`,
        { id: moveIn.id, bed_id: null },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.data.status) {
        Swal.fire("Discarded", "The bed selection has been cleared.", "success");

        // Reset moveIn state
        setMoveIn({
          id: id,
          bed_id: "",
          monthly_rate: "",
          discount: "",
          mode_of_payment: "",
          stripe_subscription_id: "",
          stripe_customer_id: "",
        });

        // Reset filters
        setFilter({
          floor_id: "",
          room_id: "",
          bedtype: "",
        });
        setIsUnitSelected(false);
        getBeds();
      } else {
        Swal.fire("Error", response.data.message || "Failed to discard unit.", "error");
      }
                        setIsDisabled(false);

    } catch (error) {
                        setIsDisabled(false);

      globalErrorHandler(error, navigate);

    }
  };



  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }


  return (
    <div className="container-fluid px-4 mt-4 mb-5  " id="guest-main">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Guest Intake Form</h3>
      </div>


      <div className="row mb-4" >

        <div className="col-lg-4 d-flex flex-row align-items-center fw-bold"><div className="icon-circle me-2"><i className="bi bi-briefcase-fill"></i></div>Details</div>
        <div className="col-lg-4 d-flex flex-row align-items-center fw-bold "><div className="icon-circle me-2"><i className="bi bi-person-fill"></i></div>Move-In</div>
        <div className="col-lg-4 d-flex flex-row align-items-center fw-bold text-secondary"><div className="icon-circle me-2"><i className="bi bi-file-earmark-check-fill"></i></div>Review</div>

      </div>

      <div className="card shadow mt-4">
        <div className="card-header">
          <h5 className="mb-0">Rental Information</h5>
        </div>
        <div className="card-body p-4">






          {!isUnitSelected ? (
            <>
              <div className="row g-4">
                {/* Filter by Property */}
                <div className="col-12">
                  <label className="form-label">Filter by Property</label>

                  <div className="row align-items-end g-2 mb-4">
                   
                    <div className="col-md-3">
                      <select className="form-select" name="floor_id" value={filter.floor_id} onChange={handleFilterChange}>
                        <option value="">Select Floor</option>
                        {floors.map(f => (
                          <option key={f.id} value={f.id}>{f.floor_name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <select className="form-select" name="room_id" value={filter.room_id} onChange={handleFilterChange}>
                        <option value="">Select Room</option>
                        {rooms.map(r => (
                          <option key={r.id} value={r.id}>{r.room_no}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-2">
                      <select className="form-select" name="bedtype" value={filter.bedtype} onChange={handleFilterChange}>
                        <option value="">Select Bed Type</option>
                        {bedTypes.map(bt => (
                          <option key={bt.id} value={bt.id}>{bt.bedtype}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-1">
                      <button type="button" className="btn btn-primary w-100" onClick={handleApplyFilters}>
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row g-4">
                <div className="col-lg-12">

                  <table className="table table-bordered table-hover">
                    <thead className="table-success">
                      <tr>
                        <th>Select</th>
                        <th>Property</th>
                        <th>Floor</th>
                        <th>Room</th>
                        <th>Bed Type</th>
                        <th>Bed #</th>

                        <th>Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      {availableBeds.length > 0 ? (
                        availableBeds.map((bed) => (
                          <tr key={bed.id}>
                            <td className="text-center">
                              <input type="radio" name="bed_id" value={bed.id} checked={moveIn.bed_id === String(bed.id)} onChange={(e) => setMoveIn(prev => ({ ...prev, bed_id: e.target.value, monthly_rate: bed.rate }))} />

                            </td>
                            <td>{bed.property_name}</td>
                            <td>{bed.floor_name}</td>
                            <td>{bed.room_no}</td>
                            <td>{bed.bedtypename}</td>
                                                        <td>{bed.bed_no}</td>

                            <td>${bed.rate}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center text-muted">
                            No beds found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

            </>

          ) : (
            <div className="row g-4">
              <div className="col-lg-12">
                <table className="table table-responsive table-bordered text-nowrap">
                  <thead className="table-success">
                    <tr>
                      <th>Property</th>
                      <th>Floor</th>
                      <th>Room</th>
                      <th>Bed Type</th>
                      <th>Bed #</th>
                      <th>Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{beds.find(b => b.id == moveIn.bed_id)?.property_name || "-"}</td>
                      <td>{beds.find(b => b.id == moveIn.bed_id)?.floor_name || "-"}</td>
                      <td>{beds.find(b => b.id == moveIn.bed_id)?.room_no || "-"}</td>
                      <td>{beds.find(b => b.id == moveIn.bed_id)?.bedtype || "-"}</td>
                     <td>{beds.find(b => b.id == moveIn.bed_id)?.bed_no || "-"}</td>

                      <td>${beds.find(b => b.id == moveIn.bed_id)?.rate || "0.00"}</td>
                    </tr>
                  </tbody>
                </table>

                {/* Move-In Details Row */}
                <div className="row g-3 border-top border-bottom my-5">
                  <div className="col-md-6 border-end border-dark-subtle mt-0 py-4">
                    <label className="form-label text-danger">Desired Move-In Date</label>
         
         
<Flatpickr
  placeholder="Select a date"
  style={{ maxWidth: "250px" }}
  className="form-control bg-transparent"
  name="desired_move_in_date"
  options={{ dateFormat: "m/d/Y" }} // show m/d/Y in input
  value={moveIn.desired_move_in_date ? new Date(moveIn.desired_move_in_date) : ""}
  onChange={([date]) => {
    setMoveIn((prev) => ({
      ...prev,
      desired_move_in_date: date ? formatDate(date) : "", // always save Y-m-d
    }));
  }}
/>
                  </div>
                  <div className="col-md-6">
                    <div className="px-2">
                      <div className="d-flex justify-content-between my-2">Rent Rate<span>${moveIn.monthly_rate || "0.00"}</span></div>
                      <div className="d-flex justify-content-between mb-2 mt-5 pt-2 "><strong>Total Due at Move-in</strong><span>${moveIn.monthly_rate || "0.00"}</span></div>
                      <div className="d-flex justify-content-between my-2 border-top pt-2"><strong>Total Due Monthly</strong><span>${moveIn.monthly_rate || "0.00"}</span></div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          )}



          <div className="d-flex flex-wrap gap-3 justify-content-center mt-4">


            {/* Go Back */}
            <button type="button" className="btn btn-lg btn-outline-dark" onClick={() => navigate(`/overseer/guest-management/guest-intake-form/${moveIn.id}`)} >
              Go Back
            </button>



            {/* Save & Next */}
            {!isUnitSelected ? (
              <button type="button" className="btn btn-lg btn-dark" onClick={handleSaveAndSelectUnit} disabled={isDisabled}  >
                Save & Select Unit
              </button>
            ) : (
              <button type="button" className="btn btn-lg btn-dark" onClick={handleSaveAndNext} disabled={isDisabled}  >
                Save & Next
              </button>
            )}

          </div>
        </div>
      </div>

    </div>
  );
};

export default GuestIntakeFormMoveIn;
